import { render, staticRenderFns } from "./socialSecurityBatchList.vue?vue&type=template&id=2548d2d7&scoped=true&"
import script from "./socialSecurityBatchList.vue?vue&type=script&lang=js&"
export * from "./socialSecurityBatchList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2548d2d7",
  null
  
)

export default component.exports